import React, {Component} from 'react'
import {Grid, Col, Button, FormGroup, FormControl, Panel, HelpBlock } from 'react-bootstrap'
import Logger from '../stores/Logger'
import {observer, inject} from 'mobx-react'
import * as helpers from '../lib/HelperFunctions'
import {Link} from 'react-router'
import '../containers/css/Login.css'

class Signup extends Component {

    constructor(props) {
        super(props)
        this.state = {
            email: '',
            password: '',
            emailValid: false,
        }
        this.resetState = this.resetState.bind(this)
    }
    resetState() {
        this.setState({
            password: '',
        })
    }
    handleSignup() {
        const {email, password} = this.state
        const {stores} = this.props
        const {store,authStore} = stores
        store.infoAlert = 'Registering...'
        window.setTimeout(() => { store.infoAlert = undefined }, 3000)
        authStore.createUser({email,password})
        .then((sucess) => {
            this.resetState()
        })
        .catch((error) =>{
            this.resetState()
            // Handle Errors here.
            var errorCode = error.code
            var errorMessage = error.message
            Logger.trackEvent('handleSingupError','error',errorCode)
            if (errorCode === 'auth/weak-password') {
                store.errorAlert = 'The password is too weak. Use at least one letter, one numeral, and six characters.'
                window.setTimeout(() => { store.errorAlert = undefined }, 8000)
            } else if(errorCode === 'auth/email-already-in-use'){
                store.infoAlert = 'The account already exists. Signing in...'
                window.setTimeout(() => { store.infoAlert = undefined }, 5000)
                authStore.signIn({
                    email,
                    password,
                }).then(this.resetState).catch(this.resetState)
            } else if(errorCode === 'auth/wrong-password'){
                store.errorAlert = 'The password is invalid or the user does not have a password.'
                window.setTimeout(() => { store.errorAlert = undefined }, 5000)
            } else {
                store.errorAlert = errorMessage
                window.setTimeout(() => { store.errorAlert = undefined }, 8000)
            }
            console.log(error)
        })
    }
    handleEmailChange(e) {
        this.setState({email: e.target.value})
        if (helpers.validateEmail(e.target.value)){
            this.setState({emailValid:true})
        }else{
            this.setState({emailValid:false})
        }
    }
    handlePasswordChange(e) {
        this.setState({password: e.target.value})
    }
    onPressEnterToSubmit(e){
        if(e.charCode === 13) {
          if(this.state.emailValid && false)
            this.handleSignup()
        }
    }    
    openTab(link){
        var win = window.open(link, '_blank')
        if (win) {
            //Browser will open a new tab
            win.focus()
        } else {
            //Browser has popups blocked
            alert('Popups on your browser are disabled, re-enable them in order to see the page.')
        }
      }
    render() {
        return (
            <Grid>
            <Col xs={10} xsOffset={1} md={4} mdOffset={4}>
              <div style={{display:'flex',justifyContent:'center'}}>
              <img src='/PreDo-logo.png' alt='PRE.DO' style={{width:'300px',height:'168px'}}/>
              </div>
              <Panel>
                <FormGroup controlId='formEmail'>
                  {/* <ControlLabel>Email</ControlLabel> */}
                  <FormControl
                    type='email'
                    placeholder='youremail@mail.com'
                    onChange={(e) => this.handleEmailChange(e)}
                  />
                </FormGroup>
                <FormGroup controlId='formPassword'>
                  {/* <ControlLabel>Password</ControlLabel> */}
                  <FormControl
                    type='password'
                    placeholder='Password'
                    onChange={(e) => this.handlePasswordChange(e)}
                    onKeyPress={(e) => this.onPressEnterToSubmit(e)} 
                    />
                    {/* <HelpBlock>
                        Use at least one letter, one numeral, and six characters.
                    </HelpBlock> */}
                </FormGroup>
                <FormGroup>
                    <span style={{display: 'block', color: '#838374'}}>Password should have:</span>
                    <ul>
                        <li style={{color: '#838374'}}>At least one number</li>
                        <li style={{color: '#838374'}}>At least one letter</li>
                        <li style={{color: '#838374'}}>At least six characters.</li>
                    </ul>
                    <div style={{display:'flex',justifyContent:'center',marginBottom: 10+'px'}}>
                    <Button disabled={true} bsStyle='primary' onClick={(e) => this.handleSignup(e)}>
                        Sign Up
                    </Button>
                    </div>
                    <HelpBlock>
                        By clicking "Sign Up", you agree to our <a style={{cursor: 'pointer'}} onClick={()=> this.openTab('https://pre.do/handelsbetingelser/')}>Terms of Service</a>. We’ll occasionally send you account related emails.
                    </HelpBlock>
                </FormGroup>
              </Panel>
              <div style={{display:'flex',justifyContent:'center'}}>
                Already have your PRE.DO account?
              </div>
              <div style={{display:'flex',justifyContent:'center'}}>
                <Link to={{ pathname: '/login' }} > 
                  <b>Log in</b>
                </Link>
              </div>
              </Col>
            </Grid>
        )
    }
}

export default inject("stores")(observer(Signup))



// WEBPACK FOOTER //
// ./src/containers/Signup.js